export default __webpack_public_path__ + "static/media/online.07849c18.svg";